import { Component, OnInit } from '@angular/core';
import { SimpleModalComponent } from '@looorent/ngx-simple-modal';

export interface StatusChangeModalModel {
  statusId: number;
  statusName: string;
}

@Component({
    selector: 'app-status-change-modal',
    template: `
    <div class="modal is-active">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Change Status to {{statusName}}</p>
        </header>
        <section class="modal-card-body">
          <div class="field">
            <label class="label">Reason for Status Change</label>
            <div class="control">
              <textarea 
                class="textarea" 
                [(ngModel)]="reason" 
                placeholder="Enter reason for status change..."
                rows="4">
              </textarea>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <div class="buttons is-right">
            <button class="button" (click)="close()">Cancel</button>
            <button class="button is-info" (click)="confirm()" [disabled]="!reason.trim()">
              Confirm Status Change
            </button>
          </div>
        </footer>
      </div>
    </div>
  `,
    styles: [`
    .modal-card {
      max-width: 500px;
      width: 90%;
    }
    .modal-card-body {
      padding: 1.5rem;
    }
    .textarea {
      resize: vertical;
      min-height: 100px;
    }
  `],
    standalone: false
})
export class StatusChangeModalComponent extends SimpleModalComponent<StatusChangeModalModel, { reason: string }> implements OnInit {
  reason: string = '';
  statusName: string = '';
  statusId: number = 0;
  model!: StatusChangeModalModel;

  constructor() {
    super();
  }

  ngOnInit() {
    if (this.model) {
      this.statusName = this.model.statusName;
      this.statusId = this.model.statusId;
    }
  }

  confirm() {
    if (this.reason.trim()) {
      this.result = { reason: this.reason.trim() };
      this.close();
    }
  }

  override close(): Promise<any> {
    return super.close();
  }
} 
